import { render, staticRenderFns } from "./TotalVariantCount.vue?vue&type=template&id=39402547&scoped=true&"
import script from "./TotalVariantCount.vue?vue&type=script&lang=js&"
export * from "./TotalVariantCount.vue?vue&type=script&lang=js&"
import style0 from "./TotalVariantCount.vue?vue&type=style&index=0&id=39402547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39402547",
  null
  
)

export default component.exports